import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";
import * as actions from "../redux/VipVipCommissionAction";
import { ProceedDialog } from "./ProceedDialog";
import { VipVipCommissionEffDialog } from "./VipVipCommissionEff";

export const VipVipCommission = ({}) => {
  const [swalProps, setSwalProps] = useState({});
  const [show, setShow] = useState(false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const startOfYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
  const endOfYesterday = new Date(yesterday.setHours(23, 59, 59, 999));
  const [fromDate, setFromDate] = useState(startOfYesterday);
  const [toDate, setToDate] = useState(endOfYesterday);
  const [bearwinlose, setBearwinlose] = useState(true);
  const [queryParams, setQueryParams] = useState();
  const [commnumber, setCommnumber] = useState("");
  const [vipvipcommtype, setVipvipcommtype] = useState("");
  const [calcbyvipcommget, setCalcbyvipcommget] = useState(false);
  const [gametype, setGametype] = useState("");
  const [lookbacktype, setLookbacktype] = useState("");

  const [commissionList, setCommissionList] = useState();
  const timeZone = "Asia/Kuala_Lumpur";
  const queryParamsRef = useRef({});

  const vipVipCommissionState = useSelector(
    ({ vipVipCommission }) => vipVipCommission,
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchVipVipCommissionUI({ action: "vipvipcommUI" })).then(
      (res) => {
        res = res.data;
        setGametype(res.gameTypeLists?.[0].gametype);
        setLookbacktype(res.lookBackTypes?.[0].code);
        setVipvipcommtype(res.vipCommType?.[0].code);
      }
    );
    return () => {
      dispatch(actions.clearVipVipCommissionList());
    };
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    queryParamsRef.current = {
      action: "vipvipcommcalculate",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      commnumber,
      vipvipcommtype,
      calcbyvipcommget: calcbyvipcommget.toString(),
      gametype: lookbacktype !== "classic" ? gametype : "",
      lookbacktype,
      bearwinlose: bearwinlose.toString(),
    };
    dispatch(actions.fetchVipVipCommissionList(queryParamsRef.current)).then(
      (resp) => {
        resp = resp.data;
        setCommissionList(resp);

        if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      }
    );
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <VipVipCommissionEffDialog
        setQueryParams={setQueryParams}
        queryParams={queryParams}
        setSwalProps={setSwalProps}
      />
      <ProceedDialog
        setSwalProps={setSwalProps}
        commissionList={commissionList}
        show={show}
        setShow={setShow}
        isClassic={true}
      />
      <div>
        <h2>{intl.formatMessage({ id: "vipVipCommission" })}</h2>
      </div>
      <div className="mb-4 text-danger fw-bold">
        * Please complete either VIP Commission/Commission (Classic) and
        continue
      </div>
      <div className="d-flex justify-content-between">
        <DateRangeComp
          initialRange={[
            { startDate: fromDate, endDate: toDate, key: "selection" },
          ]}
          onDateChange={handleDateChange}
        />
      </div>
      <div
        className="my-2 d-flex"
        style={{ borderBottom: "1px solid rgba(175, 164, 164, 0.4)" }}
      >
        <div>
          {intl.formatMessage({ id: "lookBackTypes" })}
          <div>
            <select
              className="dropdown respond-Select"
              value={lookbacktype}
              onChange={(e) => {
                setLookbacktype(e.target.value);
              }}
            >
              {vipVipCommissionState.vipVipCommissionUI?.lookBackTypes.map(
                (value, index) => (
                  <option key={index} value={value.code}>
                    {value.description}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
        <div>
          {intl.formatMessage({ id: "gameType" })}
          <div>
            <select
              className="dropdown respond-Select"
              value={gametype}
              onChange={(e) => {
                setGametype(e.target.value);
              }}
              style={lookbacktype === "classic" ? { color: "grey" } : {}}
              disabled={lookbacktype === "classic"}
            >
              {vipVipCommissionState.vipVipCommissionUI?.gameTypeLists.map(
                (value, index) => (
                  <option key={index} value={value.gametype}>
                    {value.gametype}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
      </div>
      <div className="my-2">
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-end">
            <div>
              {intl.formatMessage({ id: "commType" })}
              <div>
                <select
                  className="dropdown respond-Select mb-0"
                  value={vipvipcommtype}
                  onChange={(e) => {
                    setVipvipcommtype(e.target.value);
                  }}
                >
                  {vipVipCommissionState.vipVipCommissionUI?.vipCommType.map(
                    (value, index) => (
                      <option key={index} value={value.code}>
                        {value.description}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
            <div>
              {intl.formatMessage({ id: "commission" })}
              <div>
                <select className="dropdown respond-Select mb-0">
                  <option>{intl.formatMessage({ id: "percentage" })}(%)</option>
                </select>
              </div>
            </div>
            <input
              type="number"
              className="refund-Input"
              placeholder={intl.formatMessage({ id: "commissionNumber" })}
              value={commnumber}
              onChange={(e) => setCommnumber(e.target.value)}
            />
            <div className="form-check d-inline-block ms-2">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="bearwinlose"
                checked={bearwinlose}
                onChange={(e) => setBearwinlose(e.target.checked)}
              />
              <label className="form-check-label" for="bearwinlose">
                {intl.formatMessage({ id: "bearWinLose" })}
              </label>
            </div>
            <div className="form-check d-inline-block ms-2">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="calcByVipCommGet"
                checked={calcbyvipcommget}
                onChange={(e) => setCalcbyvipcommget(e.target.checked)}
              />
              <label className="form-check-label" for="calcByVipCommGet">
                {intl.formatMessage({ id: "calcByVipCommGet" })}
              </label>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <div className="mx-2">
              <button className="btn btn-primary" onClick={handleSearchClick}>
                {intl.formatMessage({ id: "calculate" })}
              </button>
            </div>
            {commissionList?.vipVipCommCalculateLists &&
              commissionList.vipVipCommCalculateLists.length > 0 && (
                <div>
                  <button
                    className="btn btn-success"
                    onClick={() => setShow(true)}
                  >
                    {intl.formatMessage({ id: "publish" })}
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
      {commissionList && (
        <div
          className={`rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
          style={{
            border: "1px solid grey",
            padding: "2px",
            margin: "10px 0 ",
          }}
        >
          <div style={{ width: "100%" }}>
            <table
              className="text-start table-report"
              style={{
                width: "100%",
                minWidth: "1000px",
              }}
            >
              <tbody>
                <tr>
                  <td className="col-6 ps-2 td-line">
                    {intl.formatMessage({ id: "originalRefund" }) +
                      " : " +
                      commissionList?.totalrefund}
                  </td>
                  <td className="col-6 ps-2 ">
                    {intl.formatMessage({ id: "actualRefund" }) +
                      " : " +
                      commissionList?.vipVipCommCalculateLists
                        ?.filter(
                          (memberRefund) =>
                            memberRefund.bonusgain &&
                            !isNaN(parseFloat(memberRefund.bonusgain))
                        )
                        ?.map((memberRefund) =>
                          parseFloat(memberRefund.bonusgain)
                        )
                        ?.reduce((acc, val) => acc + val, 0)
                        ?.toFixed(2) ?? "0.00"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "username" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "actualAmount" })}
                  </th>
                  <th className="member-cell text-nowrap text-end pe-2">
                    {intl.formatMessage({ id: "refund" })}
                  </th>
                  <th className="member-cell text-nowrap text-start pe-2">
                    {intl.formatMessage({ id: "effCount" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {commissionList?.vipVipCommCalculateLists &&
                commissionList.vipVipCommCalculateLists.length > 0 ? (
                  commissionList.vipVipCommCalculateLists.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile">
                          {index + 1}
                        </td>
                        <td className="member-cell text-start">
                          {report.username}
                        </td>
                        <td className="member-cell text-end">
                          {report.actamount}
                        </td>
                        <td className="member-cell text-end pe-2">
                          <input
                            type="number"
                            className="refund-Input text-end"
                            placeholder="0"
                            value={report.bonusgain}
                            onChange={(e) => {
                              setCommissionList((prev) => {
                                const updatedList = [
                                  ...prev.vipVipCommCalculateLists,
                                ];
                                updatedList[index] = {
                                  ...updatedList[index],
                                  bonusgain: e.target.value,
                                  isedited: "true",
                                };

                                return {
                                  ...prev,
                                  vipVipCommCalculateLists: updatedList,
                                };
                              });
                            }}
                          />
                        </td>
                        <td className="member-cell text-start">
                          <span
                            className={
                              report.effcount !== "0" ? "text-primary" : ""
                            }
                            style={
                              report.effcount !== "0"
                                ? { cursor: "pointer" }
                                : {}
                            }
                            onClick={() => {
                              setQueryParams({
                                ...queryParamsRef.current,
                                action: "vipvipcommefflist",
                                memberid: report.memberid,
                              });
                            }}
                          >
                            {report.effcount}
                          </span>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="9">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
